import styled from "@emotion/styled";

export const Root = styled.div({
    minHeight: 80,
});

export const AlignSpan = styled.span({
    height: 30,
    display: "inline-block",
});

export const AddButtonBlock = styled.span({
    display: "inline-block",
    verticalAlign: "baseline",
    lineHeight: "34px",
});

export const PagerBlock = styled.span({
    display: "inline-block",
    verticalAlign: "top",
    marginTop: 4,
    lineHeight: "18px",
});

export const Content = styled.div({
    marginTop: 10,
    marginLeft: 30,
});
